import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount } from "@nosto/preact"
import { useRef } from "preact/hooks";

import SelectedFilters from "./elements/SelectedFilters"
import GridToggles from "./elements/GridToggles"
import SortDropdown from "./elements/SortDropdown"
import FacetsDropdown from "./FacetsDropdown"

export default function Toolbar({ facetsOpen, toggleFacets, mobileColumns, desktopColumns, changeGridColumns }) {
    const { query, response, pageType } = useAppState();
    const selectedFiltersCount = useSelectedFiltersCount();
    const docCount = response.products?.total ?? 0;
    const facetsToggleRef = useRef(null);

    return (
        <div className="ns-toolbar">
            {(pageType !== "category") && (
                <div 
                    className="ns-toolbar__results"
                    data-nosto-element="totalResults"
                >
                    SHOWING {docCount} RESULTS "{query.query}"
                </div>
            )}
            <div className="ns-toolbar__controls">
                <div className="ns-toolbar__filter-controls">
                    <button
                        class="ns-toolbar__filter-toggle"
                        type="button"
                        onClick={toggleFacets}
                        ref={facetsToggleRef}
                    >
                        <span>Filters </span>
                        <span>
                            {facetsOpen ? "-" : "+"}
                            {/* {(selectedFiltersCount > 0) 
                                ? `(${selectedFiltersCount})`
                                : (facetsOpen) ? "-" : "+"
                            } */}
                        </span>
                    </button>
                    <SelectedFilters />
                </div>

                <div className="ns-toolbar__controls-grid-sort">
                    <GridToggles 
                        mobileColumns={mobileColumns}
                        desktopColumns={desktopColumns}
                        changeGridColumns={changeGridColumns}
                    />
                    <SortDropdown />
                </div>

            </div>
            <FacetsDropdown 
                facetsToggleRef={facetsToggleRef}
                facetsOpen={facetsOpen}
                toggleFacets={toggleFacets}
            />
        </div>
    )
}
